import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  hasCurrentPlanAnAlternativePlan,
  planIntervals,
} from "@circle-react/helpers/plansHelpers";
import type { PlanIntervals } from "@circle-react/helpers/plansHelpers";
import { useNavigate } from "@tanstack/react-router";

import { isAnnual } from "@/react/helpers/planHelpers";

import { usePlans } from "../components/SettingsApp/Plan/RegularPlan/PlansContext";

export const useBillingCycleState = () => {
  const { billingCycle, currentPlan, selectedPlan } = usePlans();
  const { currentCommunity } = usePunditUserContext();
  const navigate = useNavigate();

  const isYearly = (() => {
    if (!billingCycle && currentPlan) {
      return !currentCommunity?.is_on_trial;
    }
    return isAnnual(billingCycle);
  })();

  const shouldShowBillingCycleOptions =
    hasCurrentPlanAnAlternativePlan(selectedPlan);

  const isCurrentPlanSelected = currentPlan?.id === selectedPlan?.id;

  const isSelected = (planInterval: PlanIntervals): boolean => {
    if (!billingCycle && currentPlan) {
      return planInterval === planIntervals.year
        ? !currentCommunity?.is_on_trial
        : !!currentCommunity?.is_on_trial;
    }
    return billingCycle === planInterval;
  };

  const updateBillingCycleQueryParam = (interval: string) => {
    void navigate({
      to: ".",
      replace: true,
      search: prev =>
        ({
          ...prev,
          billing_cycle: interval,
        }) as unknown as typeof prev,
    });
  };

  const handleIntervalChange = (interval: string) => {
    updateBillingCycleQueryParam(interval);
  };

  const handleToggle = (checked: boolean) => {
    const newInterval = checked ? planIntervals.year : planIntervals.month;
    updateBillingCycleQueryParam(newInterval);
  };

  return {
    billingCycle,
    currentPlan,
    isYearly,
    shouldShowBillingCycleOptions,
    isCurrentPlanSelected,
    isSelected,
    handleIntervalChange,
    handleToggle,
    planIntervals,
  };
};
